import React from 'react';
import { styled } from "../../../stitches.config";
import { h3 } from '../../commonStyles/Fonts';
import { LocationsTypes } from './MapAnimation';

interface SlideProps extends LocationsTypes {
    index: number,
}

const Slide: React.FC<SlideProps> = ({ index, ...items }) => {

    return (
        <MapSlideStyled>
            <CenterDiv>
                <h3 className={h3()}>{items.text}</h3>
            </CenterDiv>
        </MapSlideStyled>
    )
}

export default Slide;

const MapSlideStyled = styled('div', {
    zIndex: 10,
    display: 'flex',
    position: 'relative',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: '100%',
    '&>*': {
        width: '100%',
    },
    '@bp4': {
        maxWidth: '1440px',
        '&>*': {
            width: '100%',
        },
    }
})

const CenterDiv = styled('div', {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    'h3': {
        position: 'static',
        padding: '12px 16px 12px 16px',
        color: '$grayscale100',
        backgroundColor: '$grayscale0',
    }
})